import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { post } from '../../util/api';
import {
	Box,
	Button,
	Paper,
	FormControl,
	Input,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Table,
	Chip,
	Avatar,
	Typography,
	Card,
	CardContent,
	Grid,
	Tooltip,
	IconButton,
	MenuItem,
	Select,
	InputLabel,
	TextField,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	RadioGroup,
	FormControlLabel,
	Radio,
	Divider,
} from '@mui/material';
import _ from 'lodash';

// Icons
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import PhoneIcon from '@mui/icons-material/Phone';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import StarIcon from '@mui/icons-material/Star';
import FireworkIcon from '@mui/icons-material/Celebration';
import GetAppIcon from '@mui/icons-material/GetApp';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import LinkIcon from '@mui/icons-material/Link';

const DATE_FORMAT = 'DD.MM.YY HH:mm';

const EMAIL_TEMPLATES = [
	{
		id: 'maytapi-cart-recovery-payment-declined',
		label: 'İlk Gönderim',
		icon: <ErrorIcon color="error" />,
		name: 'Complete Your Maytapi Subscription',
	},
	{
		id: 'maytapi-cart-recovery-checkout-abandoned',
		label: 'İkinci Gönderim',
		icon: <EmailIcon color="info" />,
		name: 'Still Interested? Your Maytapi Subscription is Waiting',
	},
	{
		id: 'maytapi-cart-recovery-first-discount',
		label: '%10 İndirim',
		icon: <LocalOfferIcon color="success" />,
		name: 'Complete your order today on Maytapi With %10 promo code',
		discount: '10%',
	},
	{
		id: 'maytapi-cart-recovery-second-discount',
		label: '%20 İndirim',
		icon: <FlashOnIcon color="warning" />,
		name: 'Complete your order today on Maytapi With %20 promo code',
		discount: '20%',
	},
	{
		id: 'maytapi-cart-recovery-third-discount',
		label: '%30 İndirim',
		icon: <StarIcon color="primary" />,
		name: "Complete your order today on Maytapi With %30 promo code",
		discount: '30%',
	},
	{
		id: 'maytapi-cart-recovery-last-discount',
		label: '%40 İndirim',
		icon: <FireworkIcon color="secondary" />,
		name: 'Complete your order today on Maytapi With %40 promo code',
		discount: '40%',
	},
];

const AbandonedCartRecovery = () => {
	const [state, setState] = useState({
		loading: true,
		activePage: 1,
		limit: 50,
		email: '',
		buttonloading: false,
		firstItem: 0,
		lastItem: 49,
		dataPage: 0,
		list: [],
		general: {},
		temp: {},
		column: null,
		direction: 'ascending',
		selectedUsers: [],
		filterDateFrom: '',
		filterDateTo: '',
		filterRiskLevel: 'all',
		filterMinFailures: '',
		pagination: {},
		// Note dialog state
		noteDialog: {
			open: false,
			uid: null,
			currentNote: '',
			isEdit: false,
		},
		emailDialog: {
			open: false,
			uid: null,
			email: '',
			riskLevel: '',
			extraData: null,
			selectedTemplate: '',
			isBulk: false,
			selectedUsers: [],
		},
		editingNotes: {},
		filterCheckoutSuccess: 'all',
		customEmailDialog: {
			open: false,
			to: '',
			subject: '',
			html: '',
		},
	});

	useEffect(() => {
		postData();
	}, []);

	const handleFilterSearch = () => {
		postData();
	};

	const handleClearFilters = () => {
		setState((prev) => ({
			...prev,
			email: '',
			filterRiskLevel: 'all',
			filterMinFailures: '',
			filterDateFrom: '',
			filterDateTo: '',
			activePage: 1,
			filterCheckoutSuccess: 'all',
		}));
		// Clear filters and reload data
		setTimeout(() => {
			postData();
		}, 100);
	};

	const handleCheckoutSuccessChange = (value) => {
		setState((prev) => ({
			...prev,
			filterCheckoutSuccess: prev.filterCheckoutSuccess === value ? 'all' : value,
		}));
	};

	const exportEmailsToCSV = () => {
		// Mevcut filtrelenmiş datayı al
		const dataToExport = filterData;

		if (dataToExport.length === 0) {
			alert('İndirilebilecek email yok!');
			return;
		}

		// Sadece emailleri al ve boş olanları filtrele
		const emails = dataToExport.map((item) => item.email).filter((email) => email && email.trim() !== '');

		if (emails.length === 0) {
			alert('Geçerli email adresi bulunamadı!');
			return;
		}

		// CSV içeriğini oluştur (sadece başlık + emailler)
		const csvContent = [
			'Email', // Başlık
			...emails, // Her satırda bir email
		].join('\n');

		// Dosyayı indir
		const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		const url = URL.createObjectURL(blob);
		link.setAttribute('href', url);

		// Dosya adı
		const now = new Date();
		const dateStr = now.toISOString().split('T')[0]; // YYYY-MM-DD
		const filterSuffix = filterCheckoutSuccess === 'success' ? '_satin_alanlar' : filterCheckoutSuccess === 'failed' ? '_satin_almayanlar' : '_tumunu';

		link.setAttribute('download', `emails_${dateStr}${filterSuffix}.csv`);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		alert(`${emails.length} email adresi CSV olarak indirildi!`);
	};

	const postData = async (overrideFilters = {}) => {
		const { activePage, limit, email, filterDateFrom, filterDateTo, filterRiskLevel, filterMinFailures } = state;

		// Override filters'ı kullan, yoksa state'deki değerleri kullan
		const currentFilters = {
			email: overrideFilters.email !== undefined ? overrideFilters.email : email,
			filterDateFrom: overrideFilters.filterDateFrom !== undefined ? overrideFilters.filterDateFrom : filterDateFrom,
			filterDateTo: overrideFilters.filterDateTo !== undefined ? overrideFilters.filterDateTo : filterDateTo,
			filterRiskLevel: overrideFilters.filterRiskLevel !== undefined ? overrideFilters.filterRiskLevel : filterRiskLevel,
			filterMinFailures: overrideFilters.filterMinFailures !== undefined ? overrideFilters.filterMinFailures : filterMinFailures,
		};

		let body = {
			page: parseInt(activePage) - 1,
			limit,
			filter: {},
		};

		// Apply filters
		if (currentFilters.email !== '') {
			body.filter.email = currentFilters.email;
		}

		if (currentFilters.filterDateFrom) {
			body.filter.dateFrom = currentFilters.filterDateFrom;
		}

		if (currentFilters.filterDateTo) {
			body.filter.dateTo = currentFilters.filterDateTo;
		}

		if (currentFilters.filterRiskLevel !== 'all') {
			body.filter.riskLevel = currentFilters.filterRiskLevel;
		}

		if (currentFilters.filterMinFailures) {
			body.filter.minFailures = parseInt(currentFilters.filterMinFailures);
		}

		try {
			setState((prev) => ({ ...prev, loading: true, buttonloading: true }));

			console.log('API Request Body:', body);
			const response = await post('/maytapi/admin/abandoned-cart', body);

			console.log('API Response:', response);
			let responseData = response.data;
			if (responseData.success) {
				setState((prev) => ({
					...prev,
					loading: false,
					buttonloading: false,
					list: responseData.result || [],
					general: responseData.general || {},
					pagination: responseData.pagination || {},
					temp: responseData,
				}));
			} else {
				throw new Error(response.message || 'API Error');
			}
		} catch (error) {
			console.error('Error fetching abandoned carts:', error);
			setState((prev) => ({
				...prev,
				loading: false,
				buttonloading: false,
				list: [],
				general: {},
				pagination: {},
			}));
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		let { firstItem, lastItem } = state;

		let processedValue = value;
		if (name === 'activePage' && value < 1) {
			processedValue = 1;
		}
		if (name === 'email') {
			processedValue = value.trim();
		}
		if (name === 'activePage') {
			firstItem = 0 + (processedValue - 1) * 50;
			lastItem = 49 + (processedValue - 1) * 50;
		}

		setState((prev) => ({
			...prev,
			[name]: processedValue,
			firstItem,
			lastItem,
		}));
	};

	const handleRiskLevelChange = (value) => {
		setState((prev) => ({ ...prev, filterRiskLevel: value }));
		// Yeni değeri direkt postData'ya gönder
		setTimeout(() => {
			postData({ filterRiskLevel: value });
		}, 100);
	};

	const handleSort = (clickedColumn) => {
		const { column, list, direction } = state;

		if (column !== clickedColumn) {
			setState((prev) => ({
				...prev,
				column: clickedColumn,
				list: _.sortBy(list, [clickedColumn]),
				direction: 'ascending',
			}));
			return;
		}

		setState((prev) => ({
			...prev,
			column: clickedColumn,
			list: list.reverse(),
			direction: direction === 'ascending' ? 'descending' : 'ascending',
		}));
	};

	const handleUserSelect = (uid) => {
		setState((prev) => ({
			...prev,
			selectedUsers: prev.selectedUsers.includes(uid) ? prev.selectedUsers.filter((id) => id !== uid) : [...prev.selectedUsers, uid],
		}));
	};

	const handleBulkAction = async (action) => {
		const { selectedUsers, list } = state;
		const selectedItems = list.filter((item) => selectedUsers.includes(item.uid));

		switch (action) {
			case 'email':
				openEmailDialog(null, null, null, null, true, selectedItems);
				break;
			case 'sms':
				alert(`${selectedItems.length} kullanıcıya SMS gönderme henüz aktif değil`);
				break;
			default:
				break;
		}
	};

	const sendRecoveryEmail = async () => {
		const { emailDialog } = state;
		const { uid, email, riskLevel, extraData, selectedTemplate, isBulk, selectedUsers } = emailDialog;

		try {
			setState((prev) => ({ ...prev, buttonloading: true }));

			if (isBulk) {
				// Toplu email gönderimi
				const allEmailPromises = [];
				let totalEmailCount = 0;

				selectedUsers.forEach((item) => {
					const emails = [item.email];
					const extraEmail = item.extra && item.extra.email;

					if (extraEmail && extraEmail !== item.email) {
						emails.push(extraEmail);
					}

					emails.forEach((emailAddress) => {
						totalEmailCount++;
						const emailPromise = post('/mailer/cart-recovery', {
							uid: item.uid,
							email: emailAddress,
							template_type: selectedTemplate,
							extra: {
								user_name: (item.extra && item.extra.user && item.extra.user.email) || emailAddress,
								last_event_label: item.label,
								error_message: (item.extra && item.extra.error) || '',
								product_name:
									(item.extra &&
										item.extra.checkout &&
										item.extra.checkout.prices &&
										item.extra.checkout.prices.vendor &&
										item.extra.checkout.prices.vendor.items &&
										item.extra.checkout.prices.vendor.items[0] &&
										item.extra.checkout.prices.vendor.items[0].name) ||
									'Maytapi Phone Service',
								price:
									(item.extra &&
										item.extra.checkout &&
										item.extra.checkout.prices &&
										item.extra.checkout.prices.vendor &&
										item.extra.checkout.prices.vendor.total) ||
									'$29.90',
								currency:
									(item.extra &&
										item.extra.checkout &&
										item.extra.checkout.prices &&
										item.extra.checkout.prices.vendor &&
										item.extra.checkout.prices.vendor.currency) ||
									'USD',
								checkout_url:
									item.extra && item.extra.checkout && item.extra.checkout.id
										? `https://checkout.paddle.com/checkout/complete?checkout=${item.extra.checkout.id}`
										: 'https://console.maytapi.com/subscription',
							},
						});
						allEmailPromises.push(emailPromise);
					});
				});

				const responses = await Promise.all(allEmailPromises);
				const successfulSends = responses.filter((response) => response.data.success);
				const failedSends = responses.filter((response) => !response.data.success);

				// Seçili kullanıcıları temizle
				setState((prev) => ({ ...prev, selectedUsers: [] }));

				if (failedSends.length === 0) {
					alert(
						`${selectedUsers.length} kullanıcıya toplam ${totalEmailCount} adrese "${
							EMAIL_TEMPLATES.find((t) => t.id === selectedTemplate)?.label
						}" template'i ile recovery email başarıyla gönderildi!`
					);
				} else {
					alert(
						`${selectedUsers.length} kullanıcıya ${successfulSends.length}/${totalEmailCount} email başarıyla gönderildi. ${failedSends.length} email gönderilemedi.`
					);
				}
			} else {
				const emails = [email];
				const extraEmail = extraData && extraData.email;

				if (extraEmail && extraEmail !== email) {
					emails.push(extraEmail);
				}

				const promises = emails.map((emailAddress) =>
					post('/mailer/cart-recovery', {
						uid: uid,
						email: emailAddress,
						template_type: selectedTemplate,
						extra: {
							user_name: (extraData && extraData.user && extraData.user.email) || emailAddress,
							last_event_label:
								(extraData && extraData.last_event_label) || (riskLevel === 'high' ? 'paddle-payment-declined' : 'checkout-close'),
							error_message: (extraData && extraData.error) || '',
							product_name:
								(extraData &&
									extraData.checkout &&
									extraData.checkout.prices &&
									extraData.checkout.prices.vendor &&
									extraData.checkout.prices.vendor.items &&
									extraData.checkout.prices.vendor.items[0] &&
									extraData.checkout.prices.vendor.items[0].name) ||
								'Maytapi Phone Service',
							price:
								(extraData &&
									extraData.checkout &&
									extraData.checkout.prices &&
									extraData.checkout.prices.vendor &&
									extraData.checkout.prices.vendor.total) ||
								'$29.90',
							currency:
								(extraData &&
									extraData.checkout &&
									extraData.checkout.prices &&
									extraData.checkout.prices.vendor &&
									extraData.checkout.prices.vendor.currency) ||
								'USD',
							checkout_url:
								extraData && extraData.checkout && extraData.checkout.id
									? `https://checkout.paddle.com/checkout/complete?checkout=${extraData.checkout.id}`
									: 'https://console.maytapi.com/subscription',
						},
					})
				);

				const responses = await Promise.all(promises);
				const successfulSends = responses.filter((response) => response.data.success);
				const failedSends = responses.filter((response) => !response.data.success);

				if (successfulSends.length > 0) {
					const emailCount = successfulSends.length;
					const totalEmails = responses.length;

					if (failedSends.length === 0) {
						alert(
							`"${
								EMAIL_TEMPLATES.find((t) => t.id === selectedTemplate)?.label
							}" template'i ile ${emailCount} adrese recovery email başarıyla gönderildi!`
						);
					} else {
						alert(
							`"${
								EMAIL_TEMPLATES.find((t) => t.id === selectedTemplate)?.label
							}" template'i ile ${emailCount}/${totalEmails} adrese recovery email gönderildi. ${failedSends.length} email gönderilemedi.`
						);
					}
				} else {
					alert('Email gönderme hatası: ' + failedSends[0].data.message);
				}
			}

			closeEmailDialog();
		} catch (error) {
			console.error('Email sending error:', error);
			alert('Email gönderme hatası: ' + error.message);
		} finally {
			setState((prev) => ({ ...prev, buttonloading: false }));
		}
	};

	// Note handling functions
	const openNoteDialog = useCallback((uid, currentNote = '') => {
		setState((prev) => ({
			...prev,
			noteDialog: {
				open: true,
				uid: uid,
				currentNote: currentNote,
				isEdit: !!currentNote,
			},
		}));
	}, []);

	const closeNoteDialog = useCallback(() => {
		setState((prev) => ({
			...prev,
			noteDialog: {
				open: false,
				uid: null,
				currentNote: '',
				isEdit: false,
			},
		}));
	}, []);

	const startEditingNote = useCallback((uid, currentNote = '') => {
		setState((prev) => ({
			...prev,
			editingNotes: {
				...prev.editingNotes,
				[uid]: currentNote,
			},
		}));
	}, []);

	const cancelEditingNote = useCallback((uid) => {
		setState((prev) => {
			const newEditingNotes = { ...prev.editingNotes };
			delete newEditingNotes[uid];
			return {
				...prev,
				editingNotes: newEditingNotes,
			};
		});
	}, []);

	const handleNoteChange = useCallback((uid, value) => {
		setState((prev) => ({
			...prev,
			editingNotes: {
				...prev.editingNotes,
				[uid]: value,
			},
		}));
	}, []);

	const saveNote = useCallback(
		async (uid) => {
			const noteText = state.editingNotes[uid] || '';

			try {
				setState((prev) => ({ ...prev, buttonloading: true }));

				const response = await post('/maytapi/admin/user-note', {
					uid: uid,
					note: noteText,
				});

				if (response.data.success) {
					// Update the list with the new note
					setState((prev) => {
						const newEditingNotes = { ...prev.editingNotes };
						delete newEditingNotes[uid];

						return {
							...prev,
							list: prev.list.map((item) => {
								if (item.uid === uid) {
									return {
										...item,
										user_extra: {
											...item.user_extra,
											notes: noteText,
										},
										user_notes: noteText,
									};
								}
								return item;
							}),
							editingNotes: newEditingNotes,
						};
					});

					alert('Not başarıyla kaydedildi!');
				} else {
					alert('Not kaydetme hatası: ' + response.data.message);
				}
			} catch (error) {
				console.error('Note saving error:', error);
				alert('Not kaydetme hatası: ' + error.message);
			} finally {
				setState((prev) => ({ ...prev, buttonloading: false }));
			}
		},
		[state.editingNotes]
	);

	const getStatusIcon = (status) => {
		switch (status) {
			case 'high_risk':
				return <ErrorIcon />;
			case 'medium_risk':
				return <WarningIcon />;
			case 'pending':
				return <InfoIcon />;
			case 'recovered':
				return <CheckCircleIcon />;
			default:
				return <InfoIcon />;
		}
	};

	const formatDate = (dateString) => {
		if (!dateString) return 'N/A';
		const date = new Date(dateString);
		return date.toLocaleDateString('tr-TR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
		});
	};

	const openEmailDialog = useCallback((uid, email, riskLevel, extraData, isBulk = false, selectedUsers = []) => {
		// Otomatik template seçimi (önerilen template)
		const suggestedTemplate =
			extraData?.last_event_label === 'paddle-payment-declined' ? 'maytapi-cart-recovery-payment-declined' : 'maytapi-cart-recovery-checkout-abandoned';

		setState((prev) => ({
			...prev,
			emailDialog: {
				open: true,
				uid,
				email,
				riskLevel,
				extraData,
				selectedTemplate: suggestedTemplate,
				isBulk,
				selectedUsers,
			},
		}));
	}, []);

	const closeEmailDialog = useCallback(() => {
		setState((prev) => ({
			...prev,
			emailDialog: {
				open: false,
				uid: null,
				email: '',
				riskLevel: '',
				extraData: null,
				selectedTemplate: '',
				isBulk: false,
				selectedUsers: [],
			},
		}));
	}, []);

	const handleTemplateSelect = useCallback((templateId) => {
		setState((prev) => ({
			...prev,
			emailDialog: {
				...prev.emailDialog,
				selectedTemplate: templateId,
			},
		}));
	}, []);

	const editorRef = useRef(null);

	const execFormat = (command, value = null) => {
		document.execCommand(command, false, value);
		editorRef.current?.focus();
	};

	const insertLink = () => {
		const url = prompt('Link URL girin:');
		if (url) execFormat('createLink', url);
	};

	const sendCustomEmail = async () => {
		const { customEmailDialog } = state;
		const { to, subject } = customEmailDialog;
		const html = editorRef.current?.innerHTML || '';

		if (!html || html === '<br>') {
			alert('Email içeriği boş olamaz!');
			return;
		}

		try {
			setState((prev) => ({ ...prev, buttonloading: true }));
			const response = await post('/mailer/send-custom', { email: to, subject, html });
			if (response.data.success) {
				alert('Email başarıyla gönderildi!');
				if (editorRef.current) editorRef.current.innerHTML = '';
				setState((prev) => ({
					...prev,
					customEmailDialog: { open: false, to: '', subject: '', html: '' },
				}));
			} else {
				alert('Email gönderme hatası: ' + response.data.message);
			}
		} catch (error) {
			console.error('Custom email error:', error);
			alert('Email gönderme hatası: ' + error.message);
		} finally {
			setState((prev) => ({ ...prev, buttonloading: false }));
		}
	};

	const {
		loading,
		list,
		general,
		pagination,
		email,
		buttonloading,
		activePage,
		selectedUsers,
		filterRiskLevel,
		filterMinFailures,
		noteDialog,
		editingNotes,
		emailDialog,
		filterCheckoutSuccess,
		customEmailDialog,
	} = state;

	// Server-side filtering kullanıyoruz, bu yüzden list'i olduğu gibi kullanıyoruz
	const filterData = useMemo(() => {
		let filteredList = list;

		// Checkout success filtrelemesi
		if (filterCheckoutSuccess === 'success') {
			filteredList = filteredList.filter((item) => item.checkout_success === true);
		} else if (filterCheckoutSuccess === 'failed') {
			filteredList = filteredList.filter((item) => item.checkout_success === false);
		}

		console.log('Original list length:', list.length);
		console.log('Filtered list length:', filteredList.length);
		console.log('Filter value:', filterCheckoutSuccess);

		return filteredList;
	}, [list, filterCheckoutSuccess]);
	if (loading) return <Box sx={{ textAlign: 'center', p: 4 }}>Yükleniyor...</Box>;
	return (
		<Box sx={{ p: 3 }}>
			<Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
				Abandoned Cart Recovery Dashboard
			</Typography>

			{/* Enhanced Stats Cards */}
			<Grid container spacing={3} sx={{ mb: 3 }}>
				<Grid item xs={12} sm={6} md={3}>
					<Card>
						<CardContent>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Avatar sx={{ bgcolor: '#1976d2', mr: 2 }}>
									<ShoppingCartIcon />
								</Avatar>
								<Box>
									<Typography variant="h6">{general.total_abandoned || 0}</Typography>
									<Typography variant="body2" color="text.secondary">
										Toplam Kullanıcı
									</Typography>
								</Box>
							</Box>
						</CardContent>
					</Card>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<Card>
						<CardContent>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Avatar sx={{ bgcolor: '#d32f2f', mr: 2 }}>
									<ErrorIcon />
								</Avatar>
								<Box>
									<Typography variant="h6">{general.high_risk || 0}</Typography>
									<Typography variant="body2" color="text.secondary">
										Yüksek Risk
									</Typography>
								</Box>
							</Box>
						</CardContent>
					</Card>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<Card>
						<CardContent>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Avatar sx={{ bgcolor: '#388e3c', mr: 2 }}>
									<TrendingUpIcon />
								</Avatar>
								<Box>
									<Typography variant="h6">${(general.real_potential_revenue || general.potential_revenue || 0).toFixed(2)}</Typography>
									<Typography variant="body2" color="text.secondary">
										Gerçek Potansiyel Revenue
									</Typography>
								</Box>
							</Box>
						</CardContent>
					</Card>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<Card>
						<CardContent>
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Avatar sx={{ bgcolor: '#7b1fa2', mr: 2 }}>
									<InfoIcon />
								</Avatar>
								<Box>
									<Typography variant="h6">{general.users_last_24h || 0}</Typography>
									<Typography variant="body2" color="text.secondary">
										Son 24 Saat
									</Typography>
								</Box>
							</Box>
						</CardContent>
					</Card>
				</Grid>
			</Grid>

			{/* Enhanced Filters */}
			<Paper elevation={1} sx={{ p: 2, mb: 3 }}>
				<Grid container spacing={2} alignItems="center">
					<Grid item xs={12} md={2.4}>
						<FormControl variant="outlined" size="small" fullWidth>
							<Input
								placeholder="Email ile ara..."
								value={email}
								name="email"
								onChange={handleChange}
								onKeyPress={(e) => {
									if (e.key === 'Enter') {
										handleFilterSearch();
									}
								}}
								startAdornment={<SearchIcon sx={{ mr: 1, color: 'action.active' }} />}
							/>
						</FormControl>
					</Grid>

					<Grid item xs={12} md={2}>
						<FormControl size="small" fullWidth>
							<InputLabel>Risk Seviyesi</InputLabel>
							<Select value={filterRiskLevel} onChange={(e) => handleRiskLevelChange(e.target.value)} label="Risk Seviyesi">
								<MenuItem value="all">Tüm Risk Seviyeleri</MenuItem>
								<MenuItem value="high">Yüksek Risk</MenuItem>
								<MenuItem value="medium">Orta Risk</MenuItem>
								<MenuItem value="low">Düşük Risk</MenuItem>
							</Select>
						</FormControl>
					</Grid>

					<Grid item xs={12} md={1}>
						<FormControl size="small" fullWidth>
							<Input
								placeholder="Min. Hata Sayısı"
								value={filterMinFailures}
								name="filterMinFailures"
								type="number"
								onChange={handleChange}
								onKeyPress={(e) => {
									if (e.key === 'Enter') {
										handleFilterSearch();
									}
								}}
							/>
						</FormControl>
					</Grid>

					<Grid item xs={12} md={6.6}>
						<Box sx={{ display: 'flex', gap: 1 }}>
							<Button variant="contained" size="small" disabled={buttonloading} onClick={handleFilterSearch} startIcon={<SearchIcon />}>
								Ara
							</Button>

							<Button
								variant="outlined"
								size="small"
								disabled={buttonloading}
								onClick={postData}
								startIcon={buttonloading ? <HourglassBottomIcon /> : <RefreshIcon />}
							>
								Yenile
							</Button>

							<Button variant="outlined" size="small" onClick={handleClearFilters} startIcon={<CloseIcon />}>
								Temizle
							</Button>

							<Button
								variant={filterCheckoutSuccess === 'success' ? 'contained' : 'outlined'}
								size="small"
								onClick={() => handleCheckoutSuccessChange('success')}
								startIcon={<CheckCircleIcon />}
								color="success"
								sx={{ ml: 1 }}
							>
								Satın Alanlar
							</Button>

							<Button
								variant={filterCheckoutSuccess === 'failed' ? 'contained' : 'outlined'}
								size="small"
								onClick={() => handleCheckoutSuccessChange('failed')}
								startIcon={<CloseIcon />}
								color="error"
								sx={{ ml: 1 }}
							>
								Satın Almayanlar
							</Button>

							<Button
								variant="outlined"
								size="small"
								onClick={exportEmailsToCSV}
								startIcon={<GetAppIcon />}
								color="primary"
								sx={{ ml: 1 }}
							>
								CSV
							</Button>

							<Button
								variant="outlined"
								size="small"
								onClick={() =>
									setState((prev) => ({
										...prev,
										customEmailDialog: { ...prev.customEmailDialog, open: true },
									}))
								}
								startIcon={<SendIcon />}
								color="secondary"
								sx={{ ml: 1 }}
							>
								Manuel Email
							</Button>
						</Box>
					</Grid>
				</Grid>
			</Paper>

			{/* Bulk Actions */}
			{selectedUsers.length > 0 && (
				<Paper elevation={1} sx={{ p: 2, mb: 3, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<Typography variant="body1" sx={{ fontWeight: 'bold' }}>
							{selectedUsers.length} kullanıcı seçildi
						</Typography>
						<Box sx={{ display: 'flex', gap: 1 }}>
							<Button variant="contained" size="small" onClick={() => handleBulkAction('email')} startIcon={<EmailIcon />}>
								Email Gönder
							</Button>
							<Button variant="contained" size="small" onClick={() => handleBulkAction('sms')} startIcon={<SmsIcon />}>
								SMS Gönder
							</Button>
						</Box>
					</Box>
				</Paper>
			)}

			{/* Enhanced Table */}
			{/* Enhanced Table */}
			<TableContainer component={Paper} elevation={2}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>
								<input
									type="checkbox"
									checked={selectedUsers.length === filterData.length && filterData.length > 0}
									onChange={(e) => {
										if (e.target.checked) {
											setState((prev) => ({ ...prev, selectedUsers: filterData.map((c) => c.uid) }));
										} else {
											setState((prev) => ({ ...prev, selectedUsers: [] }));
										}
									}}
								/>
							</TableCell>
							<TableCell onClick={() => handleSort('email')} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
								Email & Kullanıcı
							</TableCell>
							<TableCell onClick={() => handleSort('payment_failures')} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
								Hata Sayısı
							</TableCell>
							<TableCell onClick={() => handleSort('potential_value')} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
								Son Attempt
							</TableCell>
							<TableCell onClick={() => handleSort('checkout_success')} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
								Satın Alındı
							</TableCell>
							<TableCell onClick={() => handleSort('last_attempt_date')} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
								Son Deneme
							</TableCell>
							<TableCell onClick={() => handleSort('risk_level')} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
								Risk Seviyesi
							</TableCell>
							<TableCell>Not</TableCell>
							<TableCell>Recovery Aksiyonları</TableCell>
							<TableCell>Detaylar</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{_.map(filterData, (item) => {
							const {
								uid,
								email,
								payment_failures,
								checkout_closes,
								checkout_success,
								risk_level,
								status,
								last_attempt_date,
								last_attempt_price, // YENİ
								last_attempt_currency,
								abandoned_at,
								extra,
								user_extra,
							} = item;

							if (!uid) return null;

							const isSelected = selectedUsers.includes(uid);
							const userNote = user_extra?.notes || '';

							return (
								<React.Fragment key={uid}>
									<TableRow hover selected={isSelected}>
										<TableCell>
											<input type="checkbox" checked={isSelected} onChange={() => handleUserSelect(uid)} />
										</TableCell>

										<TableCell>
											<Box>
												<Typography variant="body2" sx={{ fontWeight: 'medium' }}>
													{email}
												</Typography>
												{extra && extra.email && (
													<Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
														Extra: {extra.email}
													</Typography>
												)}
												<Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
													<Chip
														size="small"
														label={
															status === 'high_risk'
																? 'Yüksek Risk'
																: status === 'medium_risk'
																? 'Orta Risk'
																: status === 'pending'
																? 'Bekliyor'
																: status === 'recovered'
																? 'Kurtarıldı'
																: 'Bilinmeyen'
														}
														color={
															status === 'high_risk'
																? 'error'
																: status === 'medium_risk'
																? 'warning'
																: status === 'recovered'
																? 'success'
																: 'default'
														}
														icon={getStatusIcon(status)}
													/>
												</Box>
											</Box>
										</TableCell>

										<TableCell>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
												{risk_level === 'high' && <ErrorIcon color="error" />}
												{risk_level === 'medium' && <WarningIcon color="warning" />}
												{risk_level === 'low' && <InfoIcon color="info" />}
												<Box>
													<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
														{payment_failures} ödeme hatası
													</Typography>
													<Typography variant="caption" color="text.secondary">
														{checkout_closes} checkout kapatma
													</Typography>
												</Box>
											</Box>
										</TableCell>

										<TableCell>
											<Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main' }}>
												{last_attempt_currency === 'USD' && '$'}
												{last_attempt_price ? last_attempt_price.toFixed(2) : '0.00'}
												{last_attempt_currency !== 'USD' && ` ${last_attempt_currency}`}
											</Typography>
											<Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
												Son Attempt
											</Typography>
										</TableCell>

										<TableCell>
											<Chip
												size="small"
												label={checkout_success ? 'Evet' : 'Hayır'}
												color={checkout_success ? 'success' : 'default'}
												icon={checkout_success ? <CheckCircleIcon /> : <CloseIcon />}
											/>
										</TableCell>

										<TableCell>
											<Typography variant="body2">{formatDate(last_attempt_date)}</Typography>
											<Typography variant="caption" color="text.secondary">
												{abandoned_at || 'Bilinmiyor'}
											</Typography>
										</TableCell>

										<TableCell>
											<Chip
												size="small"
												label={risk_level === 'high' ? 'Yüksek' : risk_level === 'medium' ? 'Orta' : 'Düşük'}
												color={risk_level === 'high' ? 'error' : risk_level === 'medium' ? 'warning' : 'success'}
											/>
										</TableCell>

										<TableCell>
											<Box sx={{ minWidth: 200, maxWidth: 300 }}>
												{editingNotes[uid] !== undefined ? (
													// Editing mode
													<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
														<TextField
															multiline
															rows={2}
															size="small"
															value={editingNotes[uid]}
															onChange={(e) => handleNoteChange(uid, e.target.value)}
															placeholder="Not yazın..."
															variant="outlined"
															fullWidth
														/>
														<Box sx={{ display: 'flex', gap: 1 }}>
															<Button
																size="small"
																variant="contained"
																onClick={() => saveNote(uid)}
																disabled={buttonloading}
																startIcon={<SaveIcon />}
															>
																Kaydet
															</Button>
															<Button size="small" variant="outlined" onClick={() => cancelEditingNote(uid)}>
																İptal
															</Button>
														</Box>
													</Box>
												) : (
													// View mode
													<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
														{userNote ? (
															<>
																<Typography
																	variant="body2"
																	sx={{
																		flexGrow: 1,
																		maxWidth: 200,
																		overflow: 'hidden',
																		textOverflow: 'ellipsis',
																		whiteSpace: 'nowrap',
																		cursor: 'pointer',
																	}}
																	onClick={() => startEditingNote(uid, userNote)}
																	title={userNote}
																>
																	{userNote}
																</Typography>
																<Tooltip title="Notu Düzenle">
																	<IconButton size="small" onClick={() => startEditingNote(uid, userNote)}>
																		<EditNoteIcon />
																	</IconButton>
																</Tooltip>
															</>
														) : (
															<Button
																size="small"
																variant="outlined"
																onClick={() => startEditingNote(uid, '')}
																startIcon={<NoteAddIcon />}
															>
																Not Ekle
															</Button>
														)}
													</Box>
												)}
											</Box>
										</TableCell>

										<TableCell>
											<Box sx={{ display: 'flex', gap: 1 }}>
												<Tooltip title="Email Gönder">
													<IconButton
														size="small"
														color="primary"
														onClick={() => openEmailDialog(uid, email, risk_level, extra)}
														disabled={buttonloading}
													>
														<EmailIcon />
													</IconButton>
												</Tooltip>
												<Tooltip title="SMS Gönder">
													<IconButton size="small" color="secondary" disabled>
														<SmsIcon />
													</IconButton>
												</Tooltip>
												<Tooltip title="Telefon Et">
													<IconButton size="small" color="info" disabled>
														<PhoneIcon />
													</IconButton>
												</Tooltip>
											</Box>
										</TableCell>

										<TableCell>
											<Tooltip title="Detayları Görüntüle">
												<IconButton
													size="small"
													color="primary"
													onClick={() => (window.location.href = `/yta/cartlogdetails?uid=${uid}`)}
												>
													<VisibilityIcon />
												</IconButton>
											</Tooltip>
										</TableCell>
									</TableRow>
								</React.Fragment>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>

			<Dialog open={emailDialog.open} onClose={closeEmailDialog} maxWidth="md" fullWidth>
				<DialogTitle>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<EmailIcon />
						<Typography variant="h6">{emailDialog.isBulk ? 'Toplu Email Gönder' : 'Recovery Email Gönder'}</Typography>
					</Box>
				</DialogTitle>
				<DialogContent>
					<Box sx={{ mb: 3 }}>
						{emailDialog.isBulk ? (
							<Typography variant="body2" color="text.secondary">
								{emailDialog.selectedUsers.length} kullanıcıya email göndermek için template seçin
							</Typography>
						) : (
							<Typography variant="body2" color="text.secondary">
								{emailDialog.email} adresine göndermek için template seçin
							</Typography>
						)}
					</Box>

					<RadioGroup value={emailDialog.selectedTemplate} onChange={(e) => handleTemplateSelect(e.target.value)}>
						{EMAIL_TEMPLATES.map((template) => (
							<Paper key={template.id} elevation={1} sx={{ p: 2, mb: 2 }}>
								<FormControlLabel
									value={template.id}
									control={<Radio />}
									label={
										<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
											{template.icon}
											<Box sx={{ flex: 1 }}>
												<Typography variant="body1" sx={{ fontWeight: 'medium' }}>
													{template.name}
												</Typography>
											</Box>
										</Box>
									}
									sx={{ margin: 0, width: '100%' }}
								/>
							</Paper>
						))}
					</RadioGroup>

					{emailDialog.selectedTemplate && (
						<Box sx={{ mt: 2, p: 2, bgcolor: 'primary.light', borderRadius: 1 }}>
							<Typography variant="body2" color="primary.contrastText">
								<strong>Seçilen Template:</strong> {EMAIL_TEMPLATES.find((t) => t.id === emailDialog.selectedTemplate)?.label}
							</Typography>
						</Box>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={closeEmailDialog}>İptal</Button>
					<Button
						onClick={() => sendRecoveryEmail()}
						variant="contained"
						disabled={buttonloading || !emailDialog.selectedTemplate}
						startIcon={buttonloading ? <HourglassBottomIcon /> : <SendIcon />}
					>
						{buttonloading ? 'Gönderiliyor...' : 'Email Gönder'}
					</Button>
				</DialogActions>
			</Dialog>

			{/* Note Dialog */}
			<Dialog open={noteDialog.open} onClose={closeNoteDialog} maxWidth="sm" fullWidth disableAutoFocus disableEnforceFocus>
				<DialogTitle>{noteDialog.isEdit ? 'Notu Düzenle' : 'Yeni Not Ekle'}</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Not"
						fullWidth
						multiline
						rows={4}
						variant="outlined"
						value={noteDialog.currentNote}
						onChange={(e) => handleNoteChange(e.target.value)}
						placeholder="Kullanıcı hakkında not ekleyin..."
						autoFocus={false}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={closeNoteDialog}>İptal</Button>
					<Button onClick={saveNote} variant="contained" disabled={buttonloading} startIcon={<SaveIcon />}>
						Kaydet
					</Button>
				</DialogActions>
			</Dialog>

			{/* Custom Email Dialog */}
			<Dialog
				open={customEmailDialog.open}
				onClose={() => {
					if (editorRef.current) editorRef.current.innerHTML = '';
					setState((prev) => ({ ...prev, customEmailDialog: { open: false, to: '', subject: '', html: '' } }));
				}}
				maxWidth="md"
				fullWidth
			>
				<DialogTitle>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
						<SendIcon />
						<Typography variant="h6">Manuel Email Gönder</Typography>
					</Box>
				</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Alıcı Email"
						fullWidth
						variant="outlined"
						value={customEmailDialog.to}
						onChange={(e) =>
							setState((prev) => ({
								...prev,
								customEmailDialog: { ...prev.customEmailDialog, to: e.target.value },
							}))
						}
						placeholder="ornek@mail.com"
						type="email"
					/>
					<TextField
						margin="dense"
						label="Konu"
						fullWidth
						variant="outlined"
						value={customEmailDialog.subject}
						onChange={(e) =>
							setState((prev) => ({
								...prev,
								customEmailDialog: { ...prev.customEmailDialog, subject: e.target.value },
							}))
						}
						placeholder="Email konusu..."
						sx={{ mt: 1 }}
					/>

					<Box sx={{ mt: 2 }}>
						<Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
							İçerik
						</Typography>
						{/* Toolbar */}
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								gap: 0.5,
								px: 1,
								py: 0.5,
								border: '1px solid',
								borderColor: 'divider',
								borderBottom: 'none',
								borderRadius: '4px 4px 0 0',
								bgcolor: 'grey.50',
							}}
						>
							<Tooltip title="Kalın">
								<IconButton size="small" onMouseDown={(e) => { e.preventDefault(); execFormat('bold'); }}>
									<FormatBoldIcon fontSize="small" />
								</IconButton>
							</Tooltip>
							<Tooltip title="İtalik">
								<IconButton size="small" onMouseDown={(e) => { e.preventDefault(); execFormat('italic'); }}>
									<FormatItalicIcon fontSize="small" />
								</IconButton>
							</Tooltip>
							<Tooltip title="Altı Çizili">
								<IconButton size="small" onMouseDown={(e) => { e.preventDefault(); execFormat('underline'); }}>
									<FormatUnderlinedIcon fontSize="small" />
								</IconButton>
							</Tooltip>
							<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
							<Tooltip title="Madde Listesi">
								<IconButton size="small" onMouseDown={(e) => { e.preventDefault(); execFormat('insertUnorderedList'); }}>
									<FormatListBulletedIcon fontSize="small" />
								</IconButton>
							</Tooltip>
							<Tooltip title="Numaralı Liste">
								<IconButton size="small" onMouseDown={(e) => { e.preventDefault(); execFormat('insertOrderedList'); }}>
									<FormatListNumberedIcon fontSize="small" />
								</IconButton>
							</Tooltip>
							<Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
							<Tooltip title="Link Ekle">
								<IconButton size="small" onMouseDown={(e) => { e.preventDefault(); insertLink(); }}>
									<LinkIcon fontSize="small" />
								</IconButton>
							</Tooltip>
						</Box>
						{/* Editor area */}
						<Box
							ref={editorRef}
							contentEditable
							suppressContentEditableWarning
							sx={{
								minHeight: 220,
								maxHeight: 400,
								overflowY: 'auto',
								p: 2,
								border: '1px solid',
								borderColor: 'divider',
								borderRadius: '0 0 4px 4px',
								outline: 'none',
								fontSize: '14px',
								lineHeight: 1.6,
								color: 'text.primary',
								'&:focus': { borderColor: 'primary.main', borderWidth: '2px' },
								'& ul, & ol': { pl: 3 },
								'&:empty:before': {
									content: '"Email içeriğini yazın..."',
									color: 'text.disabled',
									pointerEvents: 'none',
								},
							}}
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							if (editorRef.current) editorRef.current.innerHTML = '';
							setState((prev) => ({ ...prev, customEmailDialog: { open: false, to: '', subject: '', html: '' } }));
						}}
					>
						İptal
					</Button>
					<Button
						onClick={sendCustomEmail}
						variant="contained"
						disabled={buttonloading || !customEmailDialog.to}
						startIcon={buttonloading ? <HourglassBottomIcon /> : <SendIcon />}
					>
						{buttonloading ? 'Gönderiliyor...' : 'Gönder'}
					</Button>
				</DialogActions>
			</Dialog>

			{/* Pagination */}
			<Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, gap: 2, alignItems: 'center' }}>
				<Button
					variant="outlined"
					startIcon={<ArrowBackIcon />}
					onClick={() => {
						if (activePage > 1) {
							setState((prev) => ({ ...prev, activePage: activePage - 1 }));
							postData();
						}
					}}
					disabled={buttonloading || activePage <= 1}
				>
					Önceki
				</Button>

				<Typography variant="body2" sx={{ mx: 2 }}>
					Sayfa {activePage} - Toplam {pagination.total || list.length} kayıt
				</Typography>

				<Button
					variant="outlined"
					endIcon={<ArrowForwardIcon />}
					onClick={() => {
						setState((prev) => ({ ...prev, activePage: activePage + 1 }));
						postData();
					}}
					disabled={buttonloading || !pagination.hasMore}
				>
					Sonraki
				</Button>
			</Box>

			{/* Empty State */}
			{list.length === 0 && !loading && (
				<Box sx={{ textAlign: 'center', py: 8 }}>
					<ShoppingCartIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
					<Typography variant="h6" color="text.secondary" gutterBottom>
						Abandoned cart bulunmuyor
					</Typography>
					<Typography variant="body2" color="text.secondary">
						Filtreleri değiştirerek tekrar deneyin
					</Typography>
				</Box>
			)}
		</Box>
	);
};

export default AbandonedCartRecovery;
